import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormNavigationService } from "@m19-board/shared/form-navigation/form-navigation.service";

@Component({
  selector: "app-form-shell",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "flex h-full min-h-0 flex-col bg-white",
  },
  template: `
    <div class="shrink-0 border-b px-4 py-2 empty:hidden">
      <ng-content select="[shellHeader]" />
    </div>
    <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div class="h-full min-h-0 w-full overflow-auto">
        <div
          class="mx-auto h-full w-full"
          [class.px-4]="contentSize() !== 'full'"
          [class.px-px]="contentSize() === 'full'"
          [class.max-w-125]="contentSize() === 'sm'"
          [class.max-w-5xl]="contentSize() === 'md'"
        >
          <ng-content select="[shellMain]" />
        </div>
      </div>
    </div>
    <div class="shrink-0 border-t py-4">
      <div
        class="mx-auto w-full px-4"
        [class.max-w-125]="contentSize() === 'sm'"
        [class.max-w-5xl]="contentSize() === 'md'"
      >
        <ng-content select="[shellFooter]" />
      </div>
    </div>
  `,
})
export class FormShellComponent {
  readonly formNavigationService = inject(FormNavigationService);

  readonly contentSize = this.formNavigationService.currentStepSize;
}
